import IconWeb from "/src/assets/img/svg/web.svg";
import IconPhone from "/src/assets/img/svg/telephony.svg";
import IconRcs from "/src/assets/img/svg/rcs.svg";
import IconMail from "/src/assets/img/svg/mail.svg";
import IconScenario from "/src/assets/img/svg/scenario.svg"

export default {
    sms : IconWeb,
    rcs : IconRcs,
    phone : IconPhone,
    mail: IconMail,
    scenario: IconScenario
}